// extracted by mini-css-extract-plugin
export var summarySectionContent = "order-summary-section-module--summary-section-content--779ad";
export var titleText = "order-summary-section-module--title-text--c4e05";